export default {
  default: '/',
  coderpad: '/coderpad',
  coderpadId: '/coderpad/:id',
  pastebin: '/pastebin',
  pastebinId: '/pastebin/:id',
}